import { render } from "./Profile-main.vue?vue&type=template&id=7a634cdd&lang=pug"
import script from "./Profile-main.vue?vue&type=script&setup=true&lang=js"
export * from "./Profile-main.vue?vue&type=script&setup=true&lang=js"

import "./Profile-main.vue?vue&type=style&index=0&id=7a634cdd&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__